export const SLOT_1_START = { hour: 9, minute: 0, second: 0, };
export const SLOT_1_END = { hour: 10, minute: 0, second: 0, };

export const SLOT_2_START = { hour: 13, minute: 0, second: 0, };
export const SLOT_2_END = { hour: 14, minute: 0, second: 0, };